import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../../components';
import { PageTitle } from '../../components/Text';
import './IntroductionScreen.scss';

const IntroductionScreen = () => (
  <>
    <Header />
    <div id="main">
      <div className="container">
        <div className="content-wrap introduction">
          <PageTitle className="project-title">
            Welcome to the online form to renew a Blue CPCS Competent Operator
            Card via logbook
          </PageTitle>
          <div className="primary-content">
            <p>
              Before proceeding with the application, you MUST only complete
              this form when all renewal requirements have been met:
            </p>
            <ol>
              <li>
                Completion of the relevant Health Safety and Environment test
                within the last 2 years.
                <ul>
                  <li>
                    If your HS&amp;E has not been achieved within 2 years,
                    please book online via the NOCN Hub.
                  </li>
                  <li>
                    If you are unsure of which HS&amp;E test to take, please
                    look at the CPCS FAQ&apos;s
                  </li>
                  <li>
                    If the Specialist Supervisory (SUP) or Manager and
                    Professional (MAP) Health, Safety and Environment Test is
                    required you would need to book via Pearson Vue.
                  </li>
                  <li>
                    If you are multi trade, and require a CSCS Card, we
                    recommend you take the CITB HS&amp;E with a Pearson Vue
                    test Centre which can be used for both card schemes.
                  </li>
                </ul>
              </li>
              <li>
                Completion of the relevant Renewal CPD based on the categories
                held on your Blue CPCS Competent Card within the last 2 years.
                <ul>
                  <li>You can book the CPD online via the NOCN Hub.</li>
                </ul>
              </li>
              <li>
                Completion of the following:
                <ul>
                  <li>
                    300 hours on each category via CPCS Logbook. If the paper
                    copy is not held, you can log your hours on the Digital
                    Logbook via your NOCN HUB account. (A copy of the logbook
                    will only need to be sent if we have requested this from
                    you)
                  </li>
                </ul>
              </li>
            </ol>

            <p>
              If you are renewing via On-Site Assessment (OSA) or CPCS Practical
              Test (PT) these can be arranged through your local CPCS Accredited
              Centre.
            </p>

            <p>
              <strong>Industry Accreditation Withdrawal</strong>
            </p>

            <p>
              Due to the requirements of the Construction Leadership Council,
              CPCS Competent Operator Cards gained under Industry Accreditation
              are required to either:
            </p>
            <ul>
              <li>Achieve the NOCN CPCS Competence Interview</li>
            </ul>
            <p>Or</p>
            <ul>
              <li>
                Provide evidence of the following S/NVQ units:
                <ul>
                  <li>
                    Conforming to General Health, Safety and Welfare in the
                    Workplace
                  </li>
                  <li>
                    Conforming to Productive Working Practices in the Workplace.
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              (Or the equivalent wording on your Construction or Plant related
              occupational VQ Certificate, as issued by your Awarding
              Organisation)
            </p>
            <p>
              Card holders can complete the NOCN CPCS Competence Interview at
              any CPCS Test Centre for a maximum charge of £160+VAT/admin fee.
            </p>
            <p>
              The Competence Interview will be notified to the CPCS Team and
              applied for by the CPCS Accredited Centre.
            </p>
            <p>
              Please visit website{' '}
              <a href="https://cpcs.nocn.org.uk/CPCS/cpcs-blue-competent-operator-card/industry-accreditation-withdrawal/">
                https://cpcs.nocn.org.uk/CPCS/cpcs-blue-competent-operator-card/industry-accreditation-withdrawal/
              </a>{' '}
              for more information on the Industry Accreditation.
            </p>

            <p>
              If you require help completing this form, please contact CPCS on
              0300 999 1177 opt 1, opt 1 or email{' '}
              <a href="mailto:CPCS@nocn.org.uk">CPCS@nocn.org.uk</a>
            </p>

            <p>
              Alternatively you can also contact us via the webchat service{' '}
              <a href="https://cpcs.nocn.org.uk/contact/">
                https://cpcs.nocn.org.uk/contact
              </a>
            </p>

            <p>
              If you have met all the renewal requirements as above, you will
              be able to proceed with your application.
            </p>

            <button
              className="button introduction__action-button"
              type="button"
            >
              <Link to="/qualification" className="link">
                Proceed to application
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
);

export default IntroductionScreen;
